import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Routes from "./constants/Routes";
import Colors from "constants/Colors";

import Loader from "components/Loader";

import LoginPage from "./flows/base/pages/login";
import ForgotPasswordPage from "./flows/base/pages/forgot_password";
import ChangePasswordPage from "./flows/base/pages/change_password";
import Test1Page from "./flows/base/pages/test1";
import Test2Page from "./flows/base/pages/test2";
import HomePage from "./flows/base/pages/home";
import DocumentManagement from './flows/quotation/pages/documentManagement';

//MIRADOR//
import Page4 from './flows/embed/mirador/pages/page4';
import Page5 from './flows/embed/mirador/pages/page5';
import Page6 from './flows/embed/mirador/pages/page6';
import Page7 from './flows/embed/mirador/pages/page7';
import Page8 from './flows/embed/mirador/pages/page8';
import Page10 from './flows/embed/mirador/pages/page10';
import Page11 from './flows/embed/mirador/pages/page11';
import Page12 from './flows/embed/mirador/pages/page12';
//END MIRADOR //

import QuotationRoutes from "./flows/quotation"

// import CreateEnquirity from "./flows/quotation/pages/add";
// import EditEnquirity from "flows/quotation/pages/edit";
// import ClaimPage from "./flows/quotation/pages/claim";
// import EnquiryPage from "./flows/quotation/pages/enquiry"
// import PolicyPage from "./flows/quotation/pages/policy";
// import RenewPage from "./flows/quotation/pages/renew";

// AIO Routes
import AioRoutes from './flows/embed/aio';

import { GlobalLoaderContext } from "store/context";
import { GlobalAuthContext } from "store/context";
import { GlobalOperationContext } from 'store/context';
import { ToastContainer } from "react-toastify";
import Crypt from "utils/src/crypt";

const App = () => {
  const [loading, setLoading] = useState(false);
  const crypt = new Crypt();
  const loadingState = {
    active: loading,
    toggle: () => setLoading(!loading),
    start: () => setLoading(true),
    stop: () => setLoading(false),
  };

  const authState = localStorage.getItem('session') ?
    crypt.isValidToken(
      crypt.parseJwt(crypt.decryptJson(localStorage.getItem("session")).token)
        .exp
    )
      ? crypt.decryptJson(localStorage.getItem("session"))
      : {
        status: false,
        username: "",
        token: "",
        person_product: [],
        user_region: "",
        firstLogin: false,
        changedPassword: false,
        forgotPassword: false,
      }
    : {
      status: false,
      username: "",
      token: "",
      person_product: [],
      user_region: "",
      firstLogin: false,
      changedPassword: false,
      forgotPassword: false,
    };

  const operationState = localStorage.getItem("fitOperation") ? JSON.parse(localStorage.getItem("fitOperation"))
    :
    {
      add_response:{},
      add2_request: {},
      add2_response: {},
      issue_request: {},
      issue_response: {},
    }

  return (
    <GlobalLoaderContext.Provider value={loadingState}>
        <GlobalOperationContext.Provider value={operationState}>
          <ToastContainer newestOnTop />
          <Router basename={process.env.PUBLIC_URL}>
            <Switch>

              {/* MIRADOR */}

              <Route path={Routes.PAGE4} component={Page4} />

              <Route path={Routes.PAGE5} component={Page5} />

              <Route path={Routes.PAGE6} component={Page6} />

              <Route path={Routes.PAGE7} component={Page7} />

              <Route path={Routes.PAGE8} component={Page8} />

              <Route path={Routes.PAGE10} component={Page10} />

              <Route path={Routes.PAGE11} component={Page11} />

              <Route path={Routes.PAGE12} component={Page12} />

              {/* END MIRADOR */}

              {/* AIO PAGES */}
              <Route path={Routes.AIO} component={AioRoutes} />
              {/* END PAGES */}
              

              <Route path={Routes.LOGIN} component={LoginPage} />

              <Route path={Routes.QUOTATIONS} component={QuotationRoutes} />

              {/*****  BASE ROUTES *****/}
              <Route path={Routes.FORGOTPASSWORD} component={ForgotPasswordPage} />

              <Route path={Routes.CHANGEPASSWORD} component={ChangePasswordPage} />

              <Route path={Routes.HOME} component={HomePage} />


              <Route path={Routes.TEST1} component={Test1Page} />

              <Route path={Routes.TEST2} component={Test2Page} />
              {/* 
          <Route path={Routes.PAYMENTS} component={PaymentPage} />

          <Route path={Routes.EDITENQUIRITY} component={EditEnquirity} /> */}

              {/* <Route path={Routes.ENQUIRIES} component={EnquiryPage} />

          <Route path={Routes.POLICIES} component={PolicyPage} />

          <Route path={Routes.CLAIMS} component={ClaimPage} />}

          {/* <Route path={Routes.RENEWALS} component={RenewPage} /> */}

              {/* false && <Route path={Routes.TEST2} component={Test2Page} /> */}

              <Route path={Routes.DOCUMENTMANAGEMENT} component={DocumentManagement} />

              <Redirect to={authState.status ? Routes.HOME : Routes.LOGIN} />
            </Switch>
          </Router>
        </GlobalOperationContext.Provider>
      {loadingState.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
      <GlobalAuthContext.Provider value={authState} />
    </GlobalLoaderContext.Provider>
  );
};

export default App;